module.exports = __webpack_public_path__ + "static/media/desinvestimento.dc1ecd1b.png";